

export default function formatOrderDate(date: string, format?: string) {
    date  = date.replaceAll('/', '-')
    if(date.split("-")[0].length == 2){
        date = [date.split('-')[2], date.split('-')[1], date.split('-')[0]].join("-")
    }
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return ((format == 'JJ-MM-AAAA') ? [day, month, year] : [year, month, day]).join('-');
}